export const SaveAndContinueButtonConfigs = {
        van: true,
        motor: false,
        home: false,
        device: false,
        travel: false
}